import {
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Radio,
  useTheme,
} from "@mui/material";
import { CustomButton } from "../../../../components/Button";
import { useSelector } from "react-redux";

type LLMSelectorProps = {
  llmSelectorOptions: Array<any>;
  selectedOption: number;
  setSelectedOption: (option: number) => void;
  currentConversationId: string;
  setConfirmationProps: (props: any) => void;
  setShowConfirmation: (option: boolean) => void;
  handleProceedLlmSwitch: (option: any) => void;
  setOpen: (option: boolean) => void;
  conversationId: string | null;
  setAnchorEl: any;
};

const LLMSelector: React.FC<LLMSelectorProps> = ({
  setConfirmationProps,
  setShowConfirmation,
  conversationId,
  currentConversationId,
  llmSelectorOptions,
  setSelectedOption,
  selectedOption,
  setAnchorEl,
  setOpen,
  handleProceedLlmSwitch,
}) => {
  const metaData = useSelector((state: any) => state.metaData);

  const theme = useTheme();
  const bgdefault = theme.palette.background.default;

  return (
    <div>
      <List disablePadding>
        {llmSelectorOptions.map((option, index) => (
          <ListItem key={index} disablePadding>
            <ListItemButton
              sx={{ borderRadius: "6px" }}
              disabled={option.disabled}
              className={selectedOption == option.id ? "active-llm" : "llm"}
              onClick={() => {
                if (currentConversationId || conversationId) {
                  setShowConfirmation(true);
                  setConfirmationProps({
                    title: "WARNING",
                    bgcolor: "rgba(180, 69, 52, 1)",
                    tooltip:
                      "When you switch LLMs, we rehydrate the conversation so the new LLM can catch up",
                    content:
                      "Changing LLMs will require a HYDRATE action. Do you wish to proceed?",
                    tokens:
                      metaData.tokenMetadata.actionsTokensCost
                        ?.generate_summary,
                    btn1: "Cancel",
                    btn2: "Proceed",
                    handleBtn1: () => {
                      setAnchorEl(null);
                      setOpen(false);
                      setShowConfirmation(false);
                    },
                    handleBtn2: () => handleProceedLlmSwitch(option),
                    icon: <div></div>,
                  });
                } else {
                  setSelectedOption(option.id);
                  setAnchorEl(null);
                  setOpen(false);
                }
              }}
            >
              <ListItemIcon sx={{ minWidth: "30px" }}>
                {option.logo}
              </ListItemIcon>
              <ListItemText
                primary={option.name}
                sx={{
                  color: theme.palette.primary.main,
                  fontWeight: "200 !important",
                }}
              />
              <Radio
                checked={selectedOption === option.id}
                // onChange={handleChange}
                value={option.id}
                name="radio-buttons"
                inputProps={{ "aria-label": "A" }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider sx={{ margin: "0px 1px", backgroundColor: "#2a945f" }} />
      <div className="thread-age-btns">
        <div style={{ width: "100%" }}>
          <CustomButton
            text={"Add LLM"}
            color={bgdefault}
            bgcolor={bgdefault}
            fontWeight="500"
            fontSize="13px"
            width="100%"
            disabled
          />
        </div>
      </div>
    </div>
  );
};

export default LLMSelector;
